import { MotionConfig } from "framer-motion";
import { Direction } from "radix-ui";
import type { ReactNode } from "react";
import { Toaster } from "sonner";
import { useBulkBarVisible } from "@/components/kit/bulk-bar";
import { usePhone } from "@/components/kit/use-media-query";
import { ConfirmProvider } from "@/components/ui/confirm";
import { TooltipProvider } from "@/components/ui/overlays";
import { syncReducedMotion } from "@/lib/motion";
import { usePrefs } from "@/lib/prefs";

syncReducedMotion();

export function AppProviders({ children }: { children: ReactNode }) {
  const { lang, resolvedTheme } = usePrefs();
  const dir = lang === "ar" ? "rtl" : "ltr";
  const phone = usePhone();
  const bulk = useBulkBarVisible();
  return (
    <MotionConfig reducedMotion="user">
    <Direction.Provider dir={dir}>
      <TooltipProvider delayDuration={350} skipDelayDuration={150}>
        <ConfirmProvider>
          {children}
          <Toaster
            theme={resolvedTheme}
            dir={dir}
            // ALP-84: top centre on desktop (never over sticky footers or the bulk bar); bottom centre above the tab bar on phones
            position={phone ? "bottom-center" : "top-center"}
            closeButton
            toastOptions={{ duration: 4000 }}
            offset={{ top: 68, right: 16, bottom: 16, left: 16 }} // below the 56 px topbar: toasts never cover its search or Ask
            mobileOffset={{ bottom: bulk ? 140 : 84 }}
          />
        </ConfirmProvider>
      </TooltipProvider>
    </Direction.Provider>
    </MotionConfig>
  );
}
